import React, { FC } from 'react';
import { Grid, Button, Typography } from '@mui/material';

import linesImage from 'pages/Lines.svg';
import logoImage from 'pages/LandingPageHeader.svg';

type Props = {
  message: string;
  // Shows the Login button when given
  onLogin?: () => void;
};

// The logo, message and gradient background of the home page, also shown behind
// the sign-in dialog when a signed out user opens an /app page
export const Landing: FC<Props> = ({ message, onLogin }) => (
  <>
    <Grid
      container
      direction="column"
      spacing={1}
      justifyContent="center"
      alignItems="center"
      sx={{ height: '80vh' }}
    >
      <Grid item>
        <img src={logoImage} />
      </Grid>
      <Grid item>
        <Typography
          sx={{
            fontWeight: 400,
            fontSize: '20px',
            lineHeight: '20.32px',
            textAlign: 'center',
            marginBottom: 3,
          }}
        >
          {message}
        </Typography>
      </Grid>
      <Grid item>
        {onLogin && (
          <Button
            variant="contained"
            onClick={onLogin}
            sx={{
              backgroundColor: '#4B66F1',
              color: 'white',
              width: 219,
              height: 57,
              textTransform: 'capitalize',
              fontWeight: 800,
              fontSize: '16px',
              lineHeight: '19px',
              borderRadius: '13px',
              ':hover': {
                backgroundColor: '#3655F5',
                color: 'white',
              },
            }}
          >
            Login
          </Button>
        )}
      </Grid>
    </Grid>
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: '#F3F4F5',
        background:
          'linear-gradient(90deg,rgba(250, 197, 127, 0.1) 0%,rgba(174, 227, 243, 0.4) 100%)',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        zIndex: -1,
      }}
    >
      <Grid item>
        <img src={linesImage} />
      </Grid>
    </Grid>
  </>
);
